import uuid from '../../lib/utils/uuid'

require('../../proto/javascript/netop_rc_base_pb')
require('../../proto/javascript/netop_rc_route_pb')
require('../../proto/javascript/netop_rc_tracing_pb')
require('../../proto/javascript/netop_rc_transport_pb')
require('../../proto/javascript/netop_rc_signaling_pb')

export function createRouteMeta () {
  const routeMeta = new proto.netop.rc.route.Meta()
  routeMeta.setId(uuid.v1())
  return routeMeta
}

export function createPortalCmMeta () {
  const portalCmMeta = new proto.netop.rc.portal.cm.Meta()
  portalCmMeta.setId(uuid.v1())
  return portalCmMeta
}

export function createTransportMeta () {
  const transportMeta = new proto.netop.rc.transport.Meta()
  transportMeta.setId(uuid.v1())
  return transportMeta
}
